export const CACHE_DURATION = 30 * 60 * 1000;

export const fireLocations = [
  { lat: 39.8283, lon: -98.5795, intensity: 20 },
  { lat: 38.5, lon: -97, intensity: 30 },
];

export const usaPolygon = [
  [49.38, -125.0],
  [25.82, -125.0],
  [25.82, -66.9],
  [49.38, -66.9],
];

export const warningMarkers = [
  {
    lat: 34.0522,
    lon: -118.2437,
    city: "Los Angeles, CA",
    alert: "Very high AQI – Unhealthy air",
  },
  {
    lat: 40.7128,
    lon: -74.006,
    city: "New York, NY",
    alert: "Smog warning – Sensitive groups affected",
  },
  {
    lat: 41.8781,
    lon: -87.6298,
    city: "Chicago, IL",
    alert: "High pollution due to traffic",
  },
  {
    lat: 29.7604,
    lon: -95.3698,
    city: "Houston, TX",
    alert: "Hazardous air – Stay indoors",
  },
  {
    lat: 39.7392,
    lon: -104.9903,
    city: "Denver, CO",
    alert: "AQI elevated due to wildfire smoke",
  },
  {
    lat: 32.7157,
    lon: -117.1611,
    city: "San Diego, CA",
    alert: "Moderate pollution – Limit outdoor activity",
  },
  {
    lat: 47.6062,
    lon: -122.3321,
    city: "Seattle, WA",
    alert: "Air quality alert – Use masks outdoors",
  },
  {
    lat: 33.4484,
    lon: -112.074,
    city: "Phoenix, AZ",
    alert: "High ozone levels",
  },
  {
    lat: 44.9778,
    lon: -93.265,
    city: "Minneapolis, MN",
    alert: "Sensitive groups should avoid exertion",
  },
  {
    lat: 36.1627,
    lon: -86.7816,
    city: "Nashville, TN",
    alert: "AQI in orange zone – Moderate risk",
  },
];

export const usaMarkers = [
  {
    id: 1,
    name: "Alaska",
    position: [63.588753, -154.493062],
    current: {
      pollution: {
        aqius: 24,
      },
    },
    color: "green",
  },
  {
    id: 2,
    name: "Alabama",
    position: [32.318231, -86.902298],
    current: {
      pollution: {
        aqius: 80,
      },
    },
    color: "yellow",
  },
  {
    id: 3,
    name: "Arkansas",
    position: [35.20105, -91.831833],
    current: {
      pollution: {
        aqius: 139,
      },
    },
    color: "orange",
  },
  {
    id: 4,
    name: "Arizona",
    position: [34.048928, -111.093731],
    current: {
      pollution: {
        aqius: 150,
      },
    },
    color: "orange",
  },
  {
    id: 5,
    name: "California",
    position: [36.778261, -119.417932],
    current: {
      pollution: {
        aqius: 79,
      },
    },
    color: "yellow",
  },
  {
    id: 6,
    name: "Colorado",
    position: [39.550051, -105.782067],
    current: {
      pollution: {
        aqius: 128,
      },
    },
    color: "orange",
  },
  {
    id: 7,
    name: "Connecticut",
    position: [41.603221, -73.087749],
    current: {
      pollution: {
        aqius: 39,
      },
    },
    color: "green",
  },
  {
    id: 8,
    name: "District of Columbia",
    position: [38.905985, -77.033418],
    current: {
      pollution: {
        aqius: 36,
      },
    },
    color: "green",
  },
  {
    id: 9,
    name: "Delaware",
    position: [38.910832, -75.52767],
    current: {
      pollution: {
        aqius: 71,
      },
    },
    color: "yellow",
  },
  {
    id: 10,
    name: "Florida",
    position: [27.664827, -81.515754],
    current: {
      pollution: {
        aqius: 76,
      },
    },
    color: "yellow",
  },
  {
    id: 11,
    name: "Georgia",
    position: [32.157435, -82.907123],
    current: {
      pollution: {
        aqius: 175,
      },
    },
    color: "red",
  },
  {
    id: 12,
    name: "Hawaii",
    position: [19.898682, -155.665857],
    current: {
      pollution: {
        aqius: 169,
      },
    },
    color: "red",
  },
  {
    id: 13,
    name: "Iowa",
    position: [41.878003, -93.097702],
    current: {
      pollution: {
        aqius: 159,
      },
    },
    color: "red",
  },
  {
    id: 14,
    name: "Idaho",
    position: [44.068202, -114.742041],
    current: {
      pollution: {
        aqius: 88,
      },
    },
    color: "yellow",
  },
  {
    id: 15,
    name: "Illinois",
    position: [40.633125, -89.398528],
    current: {
      pollution: {
        aqius: 13,
      },
    },
    color: "green",
  },
  {
    id: 16,
    name: "Indiana",
    position: [40.551217, -85.602364],
    current: {
      pollution: {
        aqius: 156,
      },
    },
    color: "red",
  },
  {
    id: 17,
    name: "Kansas",
    position: [39.011902, -98.484246],
    current: {
      pollution: {
        aqius: 162,
      },
    },
    color: "red",
  },
  {
    id: 18,
    name: "Kentucky",
    position: [37.839333, -84.270018],
    current: {
      pollution: {
        aqius: 84,
      },
    },
    color: "yellow",
  },
  {
    id: 19,
    name: "Louisiana",
    position: [31.244823, -92.145024],
    current: {
      pollution: {
        aqius: 104,
      },
    },
    color: "orange",
  },
  {
    id: 20,
    name: "Massachusetts",
    position: [42.407211, -71.382437],
    current: {
      pollution: {
        aqius: 31,
      },
    },
    color: "green",
  },
  {
    id: 21,
    name: "Maryland",
    position: [39.045755, -76.641271],
    current: {
      pollution: {
        aqius: 6,
      },
    },
    color: "green",
  },
  {
    id: 22,
    name: "Maine",
    position: [45.253783, -69.445469],
    current: {
      pollution: {
        aqius: 78,
      },
    },
    color: "yellow",
  },
  {
    id: 23,
    name: "Michigan",
    position: [44.314844, -85.602364],
    current: {
      pollution: {
        aqius: 87,
      },
    },
    color: "yellow",
  },
  {
    id: 24,
    name: "Minnesota",
    position: [46.729553, -94.6859],
    current: {
      pollution: {
        aqius: 59,
      },
    },
    color: "yellow",
  },
  {
    id: 25,
    name: "Missouri",
    position: [37.964253, -91.831833],
    current: {
      pollution: {
        aqius: 122,
      },
    },
    color: "orange",
  },
  {
    id: 26,
    name: "Mississippi",
    position: [32.354668, -89.398528],
    current: {
      pollution: {
        aqius: 173,
      },
    },
    color: "red",
  },
  {
    id: 27,
    name: "Montana",
    position: [46.879682, -110.362566],
    current: {
      pollution: {
        aqius: 54,
      },
    },
    color: "yellow",
  },
  {
    id: 28,
    name: "North Carolina",
    position: [35.759573, -79.0193],
    current: {
      pollution: {
        aqius: 40,
      },
    },
    color: "green",
  },
  {
    id: 29,
    name: "North Dakota",
    position: [47.551493, -101.002012],
    current: {
      pollution: {
        aqius: 15,
      },
    },
    color: "green",
  },
  {
    id: 30,
    name: "Nebraska",
    position: [41.492537, -99.901813],
    current: {
      pollution: {
        aqius: 129,
      },
    },
    color: "orange",
  },
  {
    id: 31,
    name: "New Hampshire",
    position: [43.193852, -71.572395],
    current: {
      pollution: {
        aqius: 116,
      },
    },
    color: "orange",
  },
  {
    id: 32,
    name: "New Jersey",
    position: [40.058324, -74.405661],
    current: {
      pollution: {
        aqius: 32,
      },
    },
    color: "green",
  },
  {
    id: 33,
    name: "New Mexico",
    position: [34.97273, -105.032363],
    current: {
      pollution: {
        aqius: 12,
      },
    },
    color: "green",
  },
  {
    id: 34,
    name: "Nevada",
    position: [38.80261, -116.419389],
    current: {
      pollution: {
        aqius: 94,
      },
    },
    color: "yellow",
  },
  {
    id: 35,
    name: "New York",
    position: [43.299428, -74.217933],
    current: {
      pollution: {
        aqius: 105,
      },
    },
    color: "orange",
  },
  {
    id: 36,
    name: "Ohio",
    position: [40.417287, -82.907123],
    current: {
      pollution: {
        aqius: 90,
      },
    },
    color: "yellow",
  },
  {
    id: 37,
    name: "Oklahoma",
    position: [35.007752, -97.092877],
    current: {
      pollution: {
        aqius: 49,
      },
    },
    color: "green",
  },
  {
    id: 38,
    name: "Oregon",
    position: [43.804133, -120.554201],
    current: {
      pollution: {
        aqius: 39,
      },
    },
    color: "green",
  },
  {
    id: 39,
    name: "Pennsylvania",
    position: [41.203322, -77.194525],
    current: {
      pollution: {
        aqius: 171,
      },
    },
    color: "red",
  },
  {
    id: 40,
    name: "Puerto Rico",
    position: [18.220833, -66.590149],
    current: {
      pollution: {
        aqius: 144,
      },
    },
    color: "orange",
  },
  {
    id: 41,
    name: "Rhode Island",
    position: [41.580095, -71.477429],
    current: {
      pollution: {
        aqius: 8,
      },
    },
    color: "green",
  },
  {
    id: 42,
    name: "South Carolina",
    position: [33.836081, -81.163725],
    current: {
      pollution: {
        aqius: 77,
      },
    },
    color: "yellow",
  },
  {
    id: 43,
    name: "South Dakota",
    position: [43.969515, -99.901813],
    current: {
      pollution: {
        aqius: 7,
      },
    },
    color: "green",
  },
  {
    id: 44,
    name: "Tennessee",
    position: [35.517491, -86.580447],
    current: {
      pollution: {
        aqius: 10,
      },
    },
    color: "green",
  },
  {
    id: 45,
    name: "Texas",
    position: [31.968599, -99.901813],
    current: {
      pollution: {
        aqius: 74,
      },
    },
    color: "yellow",
  },
  {
    id: 46,
    name: "Utah",
    position: [39.32098, -111.093731],
    current: {
      pollution: {
        aqius: 133,
      },
    },
    color: "orange",
  },
  {
    id: 47,
    name: "Virginia",
    position: [37.431573, -78.656894],
    current: {
      pollution: {
        aqius: 23,
      },
    },
    color: "green",
  },
  {
    id: 48,
    name: "Vermont",
    position: [44.558803, -72.577841],
    current: {
      pollution: {
        aqius: 136,
      },
    },
    color: "orange",
  },
  {
    id: 49,
    name: "Washington",
    position: [47.751074, -120.740139],
    current: {
      pollution: {
        aqius: 84,
      },
    },
    color: "yellow",
  },
  {
    id: 50,
    name: "Wisconsin",
    position: [43.78444, -88.787868],
    current: {
      pollution: {
        aqius: 168,
      },
    },
    color: "red",
  },
  {
    id: 51,
    name: "West Virginia",
    position: [38.597626, -80.454903],
    current: {
      pollution: {
        aqius: 161,
      },
    },
    color: "red",
  },
  {
    id: 52,
    name: "Wyoming",
    position: [43.075968, -107.290284],
    current: {
      pollution: {
        aqius: 137,
      },
    },
    color: "orange",
  },
];
